import React from "react";
import {
	TBallastBackendRecord,
	TBallastRecord,
} from "../../../../../redux/app/ballast/@types";
import getSignTableRows from "./getSignTableRows";
import BallastTableRows from "./BallastTableRows";

type OwnProps = {
	isSubmitterChiefOrMaster: boolean;
	ballastRecord: TBallastRecord | TBallastBackendRecord;
	is2ndUserSection?: boolean;
};

function BallastRecordParticipantsView(props: OwnProps) {
	const { ballastRecord, is2ndUserSection = false } = props;

	return (
		<BallastTableRows
			record={ballastRecord}
			tableRows={getSignTableRows(
				ballastRecord as TBallastBackendRecord,
				is2ndUserSection
			)}
		/>
	);
}

export default BallastRecordParticipantsView;
